export default "__VITE_ASSET__NHGl2JMB__"